import styled from 'styled-components';
import React from 'react';

const FieldError = styled.div`
  font-size: 0.75rem;
  color: red;
  font-weight: 300;
  text-align: left !important;
`;

// const FieldError = () => <FieldError />;

export default FieldError;
